import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { data } from 'jquery';
import { Csp5070Service } from '../../CSPService/CSP5070/csp5070.service';
import { Csp5070Class } from '../../CSPClass/CSP5070/csp5070-class';
@Component({
  selector: 'kt-csp5070-view',
  templateUrl: './csp5070-view.component.html',
  styleUrls: ['./csp5070-view.component.scss']
})
export class Csp5070ViewComponent implements OnInit {
   lblPageTitle: string = "";
   TransportList: any[] = [];
  constructor(private router: Router,public dialogRef: MatDialogRef<Csp5070ViewComponent>, private objCsp5070Service:Csp5070Service,private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
       this.onGetDatas();
  }
   onGetDatas() {
    if (localStorage.getItem('currentUser') != null) {
                var userLoginDetails = JSON.parse(localStorage.getItem('currentUser'));
                var classobj = new Csp5070Class();
                classobj.UserNam= userLoginDetails.UserNam;
                  this.objCsp5070Service.Transport(classobj).subscribe((data) => {
                   this.TransportList = data || []; 
                });
                this.changeDetectorRef.detectChanges();
              }
            }
  
indianFormatter = new Intl.NumberFormat('en-IN', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

formatIN(value: number): string {
  const num = Number(value) || 0;
  return this.indianFormatter.format(num);
}

//Total Calculations for Transport  Fee Tab

TransportTotalAmountToPay(): number {
  return this.TransportList.reduce((sum, item) => {
    const value = Number(String(item.FeeAmount).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

TransportTotalAmountPaid(): number {
  return this.TransportList.reduce((sum, item) => {
    const value = Number(String(item.PaidAmount).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

TransportTotalAmountDue(): number {
  return this.TransportList.reduce((sum, item) => {
    const value = Number(String(item.amount_to_pay).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}
//End of Total Calculations for Transport Fee Tab

  onClose() {
  if (this.dialogRef) {
    this.dialogRef.close();
  }
}
   getComponentTitle() {
    let result =  "Transportation";
    return result;
   }
}
